import { customer, doctor, operator, superAdmin } from "../lib/constans"; // costant
import { IRouteItem } from "src/types/routeTypes";
import Page404 from "../Pages/Page404"; // 404 page for all roles
import Login from "../Pages/Admin/Login"; // admin login page
import TwoFactor from "../Pages/Admin/TwoFactor"; // two factor page
import Dashboard from "../Pages/Admin/Dashboard"; // dashboard for admin
import Roles from "../Pages/Admin/Roles"; // roles for admin
import Operators from "../Pages/Admin/Operators"; // operators for admin
import Categories from "../Pages/Admin/Categories"; // categories for amdin
import Biomarkers from "../Pages/Admin/Biomarkers"; // biomarkers for admin
import Products from "../Pages/Admin/Products"; // products for amdin
import AllOrders from "../Pages/Admin/AllOrders"; // order for admin
import OrderDetails from "../Pages/Admin/OrderDetails"; // order detail for admin
import Doctors from "src/Pages/Admin/Doctors";
import DiscussionsList from "src/Pages/Admin/DiscussionsList";
import Customers from "src/Pages/Admin/Customers";
import ViewCustomerProfile from "../Pages/Admin/ViewCustomerProfile";
import ViewDoctorProfile from "../Pages/Admin/ViewDoctorProfile";
import ViewCustomerTest from "../Pages/Admin/ViewCustomerTest";
import ViewResult from "../Pages/Admin/ViewResult";
import CustomerHealthProfile from "../Pages/Admin/CustomerHealthProfile";
import AddResult from "../Pages/Admin/AddResult";
import CustomerBioMarkerDetails from "../Pages/Admin/CustomerBioMarkerDetails";
import WithDrawal from "../Pages/Admin/WithDrawal";
import WithDrawalDetail from "../Pages/Admin/WithDrawalDetail";
import SpecializationsList from "../Pages/Admin/SpecializationsList";
import DiseasesList from "../Pages/Admin/DiseasesList";
import AllApointments from "../Pages/Admin/AllApointments";
import SingleAppointment from "../Pages/Admin/SingleAppointment";
import SupportList from "../Pages/Admin/SupportList";
import PlatformSetting from "../Pages/Admin/PlatformSetting";
import RevenueManagement from "src/Pages/Admin/RevenueManagement";
import Analytics from "src/Pages/Admin/Analytics";
import PBrands from "src/Pages/Pharmacy/Admin/PBrands";
import PMainCategories from "src/Pages/Pharmacy/Admin/PMainCategories";
import PSubCategories from "src/Pages/Pharmacy/Admin/PSubCategories";
import PChildCategories from "src/Pages/Pharmacy/Admin/PChildCategories";
// ****************** CUSTOMER PAGES ****************** //
import MyTestResult from "src/Pages/Customer/MyTestResult";
import BiomarkerDetails from "src/Pages/Customer/BiomarkerDetails";
import AppointmentDetails from "src/Pages/Customer/AppointmentDetails";
import DoctorPublicProfile from "src/Pages/Customer/DoctorPublicProfile";
import Discussions from "src/Pages/Customer/Discussions";
import DiscussionDetail from "src/Pages/Customer/DiscussionDetail";
import SupportHubs from "src/Pages/Customer/SupportHubs";
// ****************** CUSTOMER PAGES ****************** //

// ****************** DOCTOR PAGES ****************** //
import AboutMeEdit from "src/Pages/Doctor/EditProfiles/AboutMeEdit";
import WorkHistoryEdit from "src/Pages/Doctor/EditProfiles/WorkHistoryEdit";
import EducationEdit from "src/Pages/Doctor/EditProfiles/EducationEdit";
import ServicesEdit from "src/Pages/Doctor/EditProfiles/ServicesEdit";
import DiseaseEdit from "src/Pages/Doctor/EditProfiles/DiseaseEdit";
import SpecializationEdit from "src/Pages/Doctor/EditProfiles/SpecializationEdit";
import OnlineAvailabilityEdit from "src/Pages/Doctor/EditProfiles/OnlineAvailabilityEdit";
import HospitalAvailabilityEdit from "src/Pages/Doctor/EditProfiles/HospitalAvailabilityEdit";
import MyCustomer from "src/Pages/Doctor/MyCustomer";
import MyCustomerTestResults from "src/Pages/Doctor/MyCustomerTestResults";
import MyCustomerHealthProfile from "src/Pages/Doctor/MyCustomerHealthProfile";
import PayoutsAndWithDrawal from "src/Pages/Doctor/PayoutsAndWithDrawal";
// ****************** DOCTOR PAGES ****************** //

// ****************** DOCTOR AND CUSTOMER PAGES ****************** //
import Privacy from "src/Pages/DoctorsAndCustomers/Privacy";
import ActivityLog from "src/Pages/DoctorsAndCustomers/ActivityLog";
import PatientPublicProfile from "src/Pages/Doctor/PatientPublicProfile";
import PharmaInventory from "src/Pages/Pharmacy/Admin/PharmaInventory";
import HomePage from "src/Pages/Pharmacy/Admin/HomePage";
import PharmaOrders from "src/Pages/Pharmacy/Admin/PharmaOrders";
import PharmaOrderDetails from "src/Pages/Pharmacy/Admin/PharmaOrderDetails";
import DiagnosticProducts from "src/Pages/WebsitePages/DiagnosticProducts";
import DiagnosticProductDetails from "src/Pages/WebsitePages/DiagnosticProductDetails";
import PharmacyOrderDetailsView from "src/Pages/Customer/PharmacyOrderDetailsView";
import MyLists from "src/Pages/Customer/MyLists";
import PrescriptionsList from "src/Pages/Customer/PrescriptionsList";
import PrescribedDetails from "src/Pages/Customer/PrescribedDetails";
import DiagnosticPackages from "src/Pages/Admin/DiagnosticPackages";
import HomecareCategories from "src/Pages/Admin/HomecareCategories";
import HomecareServices from "src/Pages/Admin/HomecareServices";
import HomecareAppointments from "src/Pages/Admin/HomecareAppointments";
import EditCustomerProfile from "src/Pages/Admin/EditCustomerProfile";
import DashboardDiagnosticsProducts from "src/Pages/Customer/DashboardsProductsAndServices/DashboardDiagnosticsProducts";
import DashboardDiagnosticProductDetail from "src/Pages/Customer/DashboardsProductsAndServices/DashboardDiagnosticProductDetail";
import PharmaProducts from "src/Pages/WebsitePages/PharmaProducts";
import PharmaProductDetail from "src/Pages/WebsitePages/PharmaProductDetail";
import WebCareCredits from "src/Pages/WebsitePages/WebCareCredits";
import WebPharmaCategory from "src/Pages/WebsitePages/WebPharmaCategory";
import WebAllBrands from "src/Pages/WebsitePages/WebAllBrands";
import POverView from "src/Pages/Pharmacy/Admin/POverView";
import DashboardPharmacyProducts from "src/Pages/Customer/DashboardsProductsAndServices/DashboardPharmacyProducts";
import HomeCare from "src/Pages/WebsitePages/HomeCare";
import HomeCareDetail from "src/Pages/WebsitePages/HomeCareDetail";
import DashboardPharmacyProductDetail from "src/Pages/Customer/DashboardsProductsAndServices/DashboardPharmacyProductDetail";
import HomecareOverView from "src/Pages/Admin/HomecareOverView";
import DashboardHomecareSerivces from "src/Pages/Customer/DashboardsProductsAndServices/DashboardHomecareSerivces";
import DashboardHomecareSerivceDetails from "src/Pages/Customer/DashboardsProductsAndServices/DashboardHomecareSerivceDetails";
import DiagnosticPackagesWeb from "src/Pages/WebsitePages/DiagnosticPackagesWeb";
import CustomerPharmacyCart from "src/Pages/CartPages/CustomerPharmacyCart";
import PharmacyCheckout from "src/Pages/CartPages/PharmacyCheckout";
import WebsitePharmacyCart from "src/Pages/WebsitePages/WebsitePharmacyCart";
import SelectHomecareSlot from "src/Pages/Customer/DashboardsProductsAndServices/SelectHomecareSlot";
import CustomerDiagnosticCart from "src/Pages/CartPages/CustomerDiagnosticCart";
import DiagnosticCheckout from "src/Pages/CartPages/DiagnosticCheckout";
import HomeCareCheckout from "src/Pages/CartPages/HomeCareCheckout";
import UserOverview from "src/Pages/Admin/UserOverview";
import AdminHomecareAppointmentDetail from "src/Pages/Admin/AdminHomecareAppointmentDetail";
import CustomerHomecareAppointmentDetail from "src/Pages/Customer/CustomerHomecareAppointmentDetail";
import AppointmentPrescribe from "src/Pages/Doctor/AppointmentPrescribe";
import Tags from "src/Pages/Admin/Tags";
import Prescriptions from "src/Pages/Pharmacy/Admin/Prescriptions";
import PlaceOrder from "src/Pages/Pharmacy/Admin/PlaceOrder";
import HomePageWebsite from "src/Pages/WebsitePages/HomePageWebsite";
import HealthScorePage from "src/Pages/Customer/HealthScorePage";
import ProductByBrandPage from "src/Pages/Pharmacy/Website/ProductByBrandPage";
import ProductsByCategoryPage from "src/Pages/Pharmacy/Website/ProductsByCategoryPage";
import AllHealthPackagesPage from "src/Pages/Pharmacy/Website/AllHealthPackagesPage";
import ProductByHomeCarePage from "src/Pages/Pharmacy/Website/ProductByHomeCarePage";
import ProductByLabTestPage from "src/Pages/Pharmacy/Website/ProductByLabTestPage";
import ConsultADoctorPage from "src/Pages/Pharmacy/Website/ConsultADoctorPage";
import UploadPrescription from "src/Pages/WebsitePages/uploadPrescription";
import ValidPrescription from "src/Pages/WebsitePages/ValidPrescription";
import NonValidPrescription from "src/Pages/WebsitePages/NonValidPrescription";
import MyOrderDetail from "src/Pages/WebsitePages/MyOrderDetail";
import ProductDetail from "src/Pages/WebsitePages/ProductDetail";
import AllHomeCareServices from "src/Pages/Pharmacy/Website/AllHomeCareServices";
import AllBrandsPage from "src/Pages/Pharmacy/Website/AllBrandsPage";
import AllLabTestsPage from "src/Pages/Pharmacy/Website/AllLabTestsPage";
import AllSpecializationsPage from "src/Pages/Pharmacy/Website/AllSpecializationsPage";
import DiagnosticsOverview from "src/Pages/Admin/DiagnosticsOverview";
import CareCredits from "src/Pages/Admin/CareCredits";
import DoctorLogin from "src/Pages/Doctor/DoctorLogin";
import DoctorRegister from "src/Pages/Doctor/DoctorRegister";
import DoctorOtp from "src/Pages/Doctor/DoctorOtp";
import DoctorForgetPassword from "src/Pages/Doctor/DoctorForgetPassword";
import DoctorConfirmPassword from "src/Pages/Doctor/DoctorConfirmPassword";
import DoctorDashboard from "src/Pages/Doctor/DoctorDashboard";
import Appointments from "src/Pages/Customer/Appointments";
import Scheduler from "src/Pages/Customer/Scheduler";
import AccountSettings from "src/Pages/Customer/AccountSettings";
import WelComeChat from "src/Pages/ChatApp/WelComeChat";
import DoctorNotification from "src/Pages/Doctor/DoctorNotification";
import PersonalDetails from "src/Pages/Customer/PersonalDetails";
import HealthVitals from "src/Pages/Customer/HealthVitals";
import HealthBiomarkers from "src/Pages/Customer/HealthBiomarkers";
import MyOrders from "src/Pages/Customer/MyOrders";
import MyResults from "src/Pages/Customer/MyResults";
import OrderDetailsView from "src/Pages/Customer/OrderDetailsView";
import MyDoctors from "src/Pages/Customer/MyDoctors";
import ManageDoctorAccess from "src/Pages/Customer/ManageDoctorAccess";
import FindDoctors from "src/Pages/Customer/FindDoctors";
import ProfileView from "src/Pages/Customer/ProfileView";
import EditProfile from "src/Pages/Doctor/EditProfile";
import BookDoctorAppointment from "src/Pages/Doctor/BookDoctorAppointement";
import OnlineConsultations from "src/Pages/Customer/OnlineConsultations";
import SingleChat from "src/Pages/ChatApp/SingleChat";
import MyCustomerManage from "src/Pages/Doctor/MyCustomerManage";
import ToastDemo from "src/Components/ToastDemo";
import AllReviews from "src/Pages/Customer/AllReviews";
import TermsCondition from "src/Pages/Customer/TermsCondition";
import PrivacyPolicy from "src/Pages/Customer/PrivacyPolicy";
import Faqs from "src/Pages/Customer/Faqs";
// import DevPage from "src/Pages/Developer/DevPage";
// ****************** DOCTOR AND CUSTOMER PAGES ****************** //

// Define the route configuration
export const appRoutes: IRouteItem[] = [
  // website pages
  {
    path: "/",
    ele: <HomePageWebsite />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/terms-conditions",
    ele: <TermsCondition />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/privacy-policy",
    ele: <PrivacyPolicy />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/faqs",
    ele: <Faqs />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/health-score",
    ele: <HealthScorePage />,
    isProtected: true,
    layout: "website",
    role: [customer, doctor],
    fallBack: "/",
  },
  {
    path: "/orders/:type/:id/view",
    ele: <MyOrderDetail />,
    isProtected: true,
    layout: "website",
    fallBack: "/",
    role: [customer, doctor],
  },
  {
    path: "/product-detail/:id/view",
    ele: <ProductDetail />,
    isProtected: false,
    layout: "website",
    fallBack: "/",
    role: null,
  },
  {
    path: "/appointment/:id/view",
    ele: <AppointmentDetails />,
    isProtected: true,
    layout: "website",
    fallBack: "/",
    role: [customer, doctor],
  },
  {
    path: "/upload-prescription",
    ele: <UploadPrescription />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/upload-prescription/valid-prescription",
    ele: <ValidPrescription />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/upload-prescription/nonValid-prescription",
    ele: <NonValidPrescription />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/brand/:id/:tagId?",
    ele: <ProductByBrandPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/health-packages",
    ele: <AllHealthPackagesPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/brands",
    ele: <AllBrandsPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/view-home-care",
    ele: <AllHomeCareServices />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/lab-tests",
    ele: <AllLabTestsPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/all-specializations",
    ele: <AllSpecializationsPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/category/:mainCategory?/:subCategory?/:childCategory?",
    ele: <ProductsByCategoryPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/pharmacy-cart",
    ele: <WebsitePharmacyCart />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/test-result/:id/view",
    ele: <MyTestResult />,
    isProtected: true,
    layout: "website",
    fallBack: "/",
    role: [customer, doctor],
  },
  // {
  //   path: "/customer/pharmacy-cart",
  //   ele: <CustomerPharmacyCart />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/",
  //   role: [doctor, customer],
  // },
  // {
  //   path: "/customer/diagnostic-cart",
  //   ele: <CustomerDiagnosticCart />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/",
  //   role: [doctor, customer],
  // },
  // {
  //   path: "/customer/pharmacy-checkout",
  //   ele: <PharmacyCheckout />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/",
  //   role: [doctor, customer],
  // },
  // {
  //   path: "/customer/diagnostic-checkout",
  //   ele: <DiagnosticCheckout />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/",
  //   role: [doctor, customer],
  // },
  // {
  //   path: "/customer/:id/:appointmentDate/:daySlot/homecare-checkout",
  //   ele: <HomeCareCheckout />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/",
  //   role: [doctor, customer],
  // },
  {
    path: "/carecredits",
    ele: <WebCareCredits />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/diagnostic-products",
    ele: <ProductByLabTestPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  // {
  //     path: "/diagnostic-products",
  //     ele: <DiagnosticProducts />,
  //     isProtected: false,
  //     layout: "website",
  //     role: null,
  //     fallBack: "/",
  // },
  {
    path: "/diagnostic-packages",
    ele: <DiagnosticPackagesWeb />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/consult-a-doctor",
    ele: <ConsultADoctorPage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/diagnostic-product/:type/:id/view",
    ele: <DiagnosticProductDetails />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/pharmacy-products",
    ele: <PharmaProducts />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/pharmacy-products/:id/view",
    ele: <PharmaProductDetail />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/home-care",
    ele: <ProductByHomeCarePage />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  // {
  //     path: "/homecare-services",
  //     ele: <HomeCare />,
  //     isProtected: false,
  //     layout: "website",
  //     role: null,
  //     fallBack: "/",
  // },
  {
    path: "/homecare-services/:id/view",
    ele: <HomeCareDetail />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/all-brands",
    ele: <WebAllBrands />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/pharmacy/:category/:id/view",
    ele: <WebPharmaCategory />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor/login",
    ele: <DoctorLogin />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor/register",
    ele: <DoctorRegister />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor/otp",
    ele: <DoctorOtp />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor/forget-password",
    ele: <DoctorForgetPassword />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor/confirm-password",
    ele: <DoctorConfirmPassword />,
    isProtected: false,
    layout: "website",
    role: null,
    fallBack: "/",
  },
  {
    path: "/doctor-public-profile/:id/view",
    ele: <DoctorPublicProfile />,
    isProtected: false,
    layout: "website",
    fallBack: "/",
    role: null,
  },
  {
    path: "/bio-details/:uid/:bioId/view",
    ele: <BiomarkerDetails />,
    isProtected: true,
    layout: "website",
    fallBack: "/",
    role: [customer, doctor],
  },

  {
    path: "/customer/homecare-appointment/:id/view",
    ele: <CustomerHomecareAppointmentDetail />,
    isProtected: true,
    layout: "website",
    fallBack: "/",
    role: [customer],
  },

  // website pages END

  {
    path: "/admin/login",
    ele: <Login />,
    isProtected: false,
    layout: "none",
    role: null,
    fallBack: "/admin",
  },
  {
    path: "/admin/otp",
    ele: <TwoFactor />,
    isProtected: false,
    layout: "none",
    role: null,
    fallBack: "/admin",
  },
  {
    path: "/admin",
    ele: <Dashboard />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/roles",
    ele: <Roles />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/operators",
    ele: <Operators />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/user/overview",
    ele: <UserOverview />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/customers",
    ele: <Customers />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/doctors",
    ele: <Doctors />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/discussions-list",
    ele: <DiscussionsList />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/diagnostics/overview",
    ele: <DiagnosticsOverview />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/diagnostics/categories",
    ele: <Categories />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/diagnostics/biomarkers",
    ele: <Biomarkers />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/diagnostics/products",
    ele: <Products />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/overview",
    ele: <POverView />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/brands",
    ele: <PBrands />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/main-categories",
    ele: <PMainCategories />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/sub-categories",
    ele: <PSubCategories />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/child-categories",
    ele: <PChildCategories />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/pharma-inventory",
    ele: <PharmaInventory />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/prescriptions",
    ele: <Prescriptions />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/pharmacy/place-order",
    ele: <PlaceOrder />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  // {
  //     path: "/admin/pharmacy/website-manage",
  //     ele: <HomePage />,
  //     isProtected: true,
  //     layout: "admin",
  //     fallBack: "/admin/login",
  //     role: [superAdmin, operator],
  // },
  {
    path: "/admin/pharmacy/all-orders",
    ele: <PharmaOrders />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/homecare-overview",
    ele: <HomecareOverView />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/homecare-categories",
    ele: <HomecareCategories />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/homecare-services",
    ele: <HomecareServices />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/homecare-appointments",
    ele: <HomecareAppointments />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/homecare-appointment/:id/view",
    ele: <AdminHomecareAppointmentDetail />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/packages",
    ele: <DiagnosticPackages />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/pharmacy/order-details/:orderId/view",
    ele: <PharmaOrderDetails />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/all-orders",
    ele: <AllOrders />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/order-details/:orderId/View",
    ele: <OrderDetails />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/customer/:uid/View",
    ele: <ViewCustomerProfile />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/user-profile-admin/:uid/edit",
    ele: <EditCustomerProfile />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/doctor/:uid/View",
    ele: <ViewDoctorProfile />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/health-profile/:uid/View",
    ele: <CustomerHealthProfile />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/add-result/:uid/view",
    ele: <AddResult />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/view/:uId/all-test",
    ele: <ViewCustomerTest />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/result/:uid/view",
    ele: <ViewResult />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/biomarker-result/:uid/:bioId/view",
    ele: <CustomerBioMarkerDetails />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/withdrawal-requests",
    ele: <WithDrawal />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/withdrawal/:id/view",
    ele: <WithDrawalDetail />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/specialization",
    ele: <SpecializationsList />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/disease",
    ele: <DiseasesList />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/all-appointments",
    ele: <AllApointments />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/single-appointment/:id/view",
    ele: <SingleAppointment />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/supporthub",
    ele: <SupportList />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  // {
  //   path: "/admin/care-credits",
  //   ele: <CareCredits />,
  //   isProtected: true,
  //   layout: "admin",
  //   fallBack: "/admin/login",
  //   role: [superAdmin, operator],
  // },
  {
    path: "/platform-settings",
    ele: <PlatformSetting />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/revenue-management",
    ele: <RevenueManagement />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/analytics",
    ele: <Analytics />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/tags",
    ele: <Tags />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  {
    path: "/admin/manage-home-page",
    ele: <HomePage />,
    isProtected: true,
    layout: "admin",
    fallBack: "/admin/login",
    role: [superAdmin, operator],
  },
  // ******************* CUSTOMER ******************* //
  {
    path: "/customer/diagnostic-products",
    ele: <DashboardDiagnosticsProducts />,
    isProtected: true,
    layout: "customer",
    fallBack: "/login",
    role: [customer, doctor],
  },
  // {
  //   path: "/customer/diagnostic-product-detail/:type/:id/view",
  //   ele: <DashboardDiagnosticProductDetail />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  {
    path: "/customer/pharmacy-products",
    ele: <DashboardPharmacyProducts />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // {
  //   path: "/customer/pharmacy-product-detail/:id/view",
  //   ele: <DashboardPharmacyProductDetail />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  {
    path: "/doctor/homecareservices",
    ele: <DashboardHomecareSerivces />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // {
  //   path: "/customer/homecareservices/:id/view",
  //   ele: <DashboardHomecareSerivceDetails />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  // {
  //   path: "/customer/service/:id/view",
  //   ele: <SelectHomecareSlot />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  {
    path: "/dashboard",
    ele: <DoctorDashboard />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/orders",
    ele: <MyOrders />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/results",
    ele: <MyResults />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-lists",
    ele: <MyLists />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/prescriptions",
    ele: <PrescriptionsList />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/prescribed-details/:productType/:id/view",
    ele: <PrescribedDetails />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/order/:id/view",
    ele: <OrderDetailsView />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/homecare-appointment/:id/view",
    ele: <CustomerHomecareAppointmentDetail />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // // {
  // //   path: "/product/:id/view",
  // //   ele: <OrderDetailsView />,
  // //   isProtected: true,
  // //   layout: "customer",
  // //   fallBack: "/login",
  // //   role: [customer, doctor],
  // // },
  // {
  //   path: "/pharmacy/order/:id/view",
  //   ele: <PharmacyOrderDetailsView />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  {
    path: "/account-settings",
    ele: <AccountSettings />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/edit-profile",
    ele: <EditProfile />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/profile-view",
    ele: <ProfileView />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/demo",
    ele: <ToastDemo />,
    isProtected: false,
    layout: "website",
    fallBack: "/",
    role: null,
  },
  {
    path: "/personal-details",
    ele: <PersonalDetails />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/health-vitals",
    ele: <HealthVitals />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/health-biomarkers",
    ele: <HealthBiomarkers />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // {
  //   path: "/checkout-payment",
  //   ele: <CheckOutAndPayment />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [customer, doctor],
  // },
  {
    path: "/find-doctors",
    ele: <FindDoctors />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/book-appointment/:did/:hid/view",
    ele: <BookDoctorAppointment />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/appointments",
    ele: <Appointments />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/appointment/:id/view",
    ele: <AppointmentDetails />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/appointment/:appointmentId/prescribe",
    ele: <AppointmentPrescribe />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-doctors",
    ele: <MyDoctors />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/:id/access",
    ele: <ManageDoctorAccess />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // {
  //     path: "/doctor-public-profile/:id/view",
  //     ele: <DoctorPublicProfile />,
  //     isProtected: true,
  //     layout: "customer",
  //     fallBack: "/doctor/login",
  //     role: [doctor, customer],
  // },
  {
    path: "/discussions",
    ele: <Discussions />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/discussion/:id/detail",
    ele: <DiscussionDetail />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/scheduler",
    ele: <Scheduler />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/message",
    ele: <WelComeChat />,
    isProtected: true,
    layout: "chat",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/message/:id/view",
    ele: <SingleChat />,
    isProtected: true,
    layout: "chat",
    fallBack: "/doctor/login",
    role: [customer, doctor],
  },
  {
    path: "/notifications",
    ele: <DoctorNotification />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/support-hub",
    ele: <SupportHubs />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/allreviews/:id/view",
    ele: <AllReviews />,
    isProtected: false,
    layout: "website",
    fallBack: "/",
    role: [customer],
  },
  {
    path: "/allreviews/:id/view",
    ele: <AllReviews />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/online-consultation/:appoinmentId/:roomId/view",
    ele: <OnlineConsultations />,
    isProtected: true,
    layout: "none",
    fallBack: "/",
    role: [customer, doctor],
  },
  // // ******************* CUSTOMER ******************* //

  // // ******************* DOCTOR AND CUSTOMER PAGES ******************* //
  // {
  //   path: "/privacy",
  //   ele: <Privacy />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/doctor/login",
  //   role: [doctor],
  // },
  {
    path: "/activity",
    ele: <ActivityLog />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // // ******************* DOCTOR AND CUSTOMER PAGES ******************* //

  // // ******************* DOCTOR ******************* //
  {
    path: "/aboutme",
    ele: <AboutMeEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/workhistory",
    ele: <WorkHistoryEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/education",
    ele: <EducationEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-services",
    ele: <ServicesEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-diseases",
    ele: <DiseaseEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-specialization",
    ele: <SpecializationEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/online-availability",
    ele: <OnlineAvailabilityEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/physical-availability",
    ele: <HospitalAvailabilityEdit />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/my-customers",
    ele: <MyCustomer />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  {
    path: "/doctor/my-customers/manage/:id",
    ele: <MyCustomerManage />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },
  // {
  //   path: "/patient-public/:id/profile",
  //   ele: <PatientPublicProfile />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/doctor/login",
  //   role: [doctor],
  // },
  // {
  //   path: "/customer-tests/:id/view",
  //   ele: <MyCustomerTestResults />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [doctor],
  // },
  // {
  //   path: "/customer-healthprofile/:id/view",
  //   ele: <MyCustomerHealthProfile />,
  //   isProtected: true,
  //   layout: "customer",
  //   fallBack: "/login",
  //   role: [doctor],
  // },
  {
    path: "/payouts-withdrawal",
    ele: <PayoutsAndWithDrawal />,
    isProtected: true,
    layout: "customer",
    fallBack: "/doctor/login",
    role: [doctor],
  },

  // ******************* DOCTOR ******************* //

  {
    path: "/*",
    ele: <Page404 />,
    isProtected: false,
    layout: "none",
    role: null,
  },

  // {
  //     path: "/developer-tools",
  //     ele: <DevPage />,
  //     isProtected: true,
  //     layout: "none",
  //     fallBack: "/admin/login",
  //     role: [superAdmin, operator],
  // }, // only for developer
];
